import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AngularFireAuth } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
import { UserProfileComponent } from '../user-profile/user-profile.component';
declare interface RouteInfo {
  path: string;
  title: string;
  type: string
}

export const ROUTES: RouteInfo[] = [
  { path: '/create-appliance', title: 'Category', type: '' },
  { path: '/create-appliance', title: 'Air Condition', type: 'AC' }

];

@Component({
  selector: 'app-vyas-navbar',
  templateUrl: './vyas-navbar.component.html',
  styleUrls: ['./vyas-navbar.component.scss']
})
export class VyasNavbarComponent implements OnInit {

  public menuItems: any[];
  public location: Location;
  titlee: any;
  version: any;
  constructor(location: Location, private element: ElementRef, public router: Router, public afAuth: AngularFireAuth) { }

  ngOnInit(): void {
    this.version = environment.version
    this.menuItems = ROUTES.filter(menuItem => menuItem);

  }

  getTitle() {

    for (var item = 0; item < this.menuItems.length; item++) {
      if (this.menuItems[item].path === this.router.url) {
        return this.menuItems[item].title;
      }
    }
    return 'login';
  }

  logout() {
    this.afAuth.signOut();
    localStorage.clear();
    this.router.navigate(['/login']);
    localStorage.removeItem('user')
  }
}
